import { render, staticRenderFns } from "./EditBankForm.vue?vue&type=template&id=5ed561d2&scoped=true&"
import script from "./EditBankForm.vue?vue&type=script&lang=js&"
export * from "./EditBankForm.vue?vue&type=script&lang=js&"
import style0 from "./EditBankForm.vue?vue&type=style&index=0&id=5ed561d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed561d2",
  null
  
)

export default component.exports